import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Provider } from './MarkProductContext';

class MarkProductProvider extends Component {
    static propTypes = {
        markProductAsBought: PropTypes.func.isRequired,
        markProductAsNotBought: PropTypes.func.isRequired,
        children: PropTypes.node.isRequired,
    };

    render() {
        const { markProductAsBought, markProductAsNotBought } = this.props;

        const providedValue = {
            markProductAsBought,
            markProductAsNotBought,
        };
        return <Provider value={providedValue}>{this.props.children}</Provider>;
    }
}

export default MarkProductProvider;
